import clsx from 'clsx'
import {useTranslation} from 'react-i18next'
import {FiBell} from 'react-icons/fi'
import styled, {keyframes} from 'styled-components'
import {NotificationBox} from './NotificationBox'
import {NotificationItem} from './NotificationItem'
import {ViewAllButton} from './ViewAllButton'
import {useNotificationTopbar} from './useNotificationTopbar'
import {NotificationAmount} from './NotificationAmount'
import { useReducer, useState } from 'react'
import { markAllNotificationAsRead } from 'src/services/fetcher'
import swal from 'sweetalert'

const Wrapper = styled.div`
  z-index: 100000 !important;
`

export const NotificationTopbar = () => {
  const {t} = useTranslation()
  const {unreadNotifications, isLoading, isError, refresh} = useNotificationTopbar()
  const [compKey, forceUpdate] = useState(0); 

  const [loadingRead, setLoadingRead] = useState(false)

  const markAllAsRead = async () => {
    setLoadingRead(true)
    try{
      await markAllNotificationAsRead(
        localStorage.getItem('credential') || '',
        {
          ids: unreadNotifications.map((item: any) => item.id)
        }
      )
      refresh()
      forceUpdate(prev => prev + 1);
    }catch(e: any){
      swal({
        title: "Error",
        text: e.response?.data?.message || e.response?.message,
        icon: "error"
      })
    }
    setLoadingRead(false)
  }

  return (
    <>
      <div id='notification-topbar' className='d-flex align-items-stretch flex-shrink-0'>
        <div
          className={clsx(
            'cursor-pointer symbol d-flex align-items-center symbol-30px symbol-md-40px position-relative'
          )}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-start'
          data-kt-menu-flip='bottom'
        >
          <FiBell size={24} />
          <NotificationAmount _key={compKey}/>
        </div>

        <Wrapper
          className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-300px'
          data-kt-menu='true'
        >
          {isLoading ? (
            <NotificationBox type='loading-message' text={t('NotificationTopbar.loadingMessage')} />
          ) : isError ? (
            <NotificationBox type='error-message' text={t('NotificationTopbar.errorMessage')} />
          ) : !unreadNotifications.length ? (
            <NotificationBox type='empty-message' text={t('NotificationTopbar.emptyMessage')} />
          ) : (
            <>
              {unreadNotifications
                ?.map((item, index) => <NotificationItem key={index} item={item} />)
                .slice(0, 5)}
              
              <div className='d-flex justify-content-center border-top mt-4 pt-4'>
                <button className='btn btn-link text-primary font-weight-bold p-0' type='button' disabled={loadingRead} onClick={() => markAllAsRead()}>
                  {
                   loadingRead ? <i className='fas fa-spin fa-spinner'></i> : t('mark-as-read')
                  }
                </button>
              </div>

              <ViewAllButton />

            </>
          )}
        </Wrapper>
      </div>
    </>
  )
}
